import { useFeatureFlags } from '@node-space/hooks'

export interface WebhooksRequestConfig {
  baseUrl: string
  apiPath: string
  apiPathV2: string
  authenticated?: boolean
  config?: { withCredentials: boolean }
}

export const useWebhooksRequestConfig = (): WebhooksRequestConfig => {
  const { enableWebhooksBff } = useFeatureFlags()

  if (enableWebhooksBff) {
    return {
      baseUrl: process.env.VITE_BASE_URL ?? '',
      apiPath: '/webhooks',
      apiPathV2: '/webhooks',
      authenticated: true,
      config: { withCredentials: true },
    }
  }

  return { baseUrl: process.env.API_URL ?? '', apiPath: '/notification/v1', apiPathV2: '/notification/v2' }
}
